import "@fontsource-variable/inter";
import "./styles.css";
import { createRoot } from "react-dom/client";
import { loadMe } from "./lib/session.ts";
import { startSync } from "./lib/sync.ts";
import { LoginPage } from "./pages/LoginPage.tsx";
import { AppShell } from "./shell/AppShell.tsx";

const root = createRoot(document.getElementById("root") as HTMLElement);

async function boot() {
  if (location.pathname === "/login") return root.render(<LoginPage />);
  const user = await loadMe();
  if (!user) return location.replace(`/login?next=${encodeURIComponent(location.pathname + location.search)}`);
  root.render(<AppShell />);
  await startSync();
}

boot();
